import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import TextButton from 'LuxKit/Button/TextButton'

interface Props {
  onBack: () => void
}

function LuxPlusManageAccountModalUpdatePaymentMethodSuccess(props: Props) {
  const { onBack } = props
  const intl = useIntl()

  return <>
    <ModalHeader title={intl.formatMessage({
      id: 'L1W3NbUspw-lvZGgHv6E',
      defaultMessage: 'Payment method updated',
      description: 'Title for the payment method updated success modal',
    })}
    />
    <ModalBody>
      <ModalContent>
        <BodyText variant="small">
          {intl.formatMessage({
            id: 'uJvkiKA89wwiQNdxjndd',
            defaultMessage: 'Your credit card has been successfully linked to your LuxPlus+ membership. It will be automatically charged on your renewal.',
            description: 'Success message confirming the payment method has been linked to the membership',
          })}
        </BodyText>
        <Group direction="horizontal" horizontalAlign="end" gap={20}>
          <TextButton
            kind="primary"
            data-testid="luxplus-update-payment-close"
            size="large"
            fit="mobile-full-width"
            id="luxplus-update-payment-close-button"
            onClick={onBack}
          >
            {intl.formatMessage({
              id: 'Dh40GvgXBdvDewnZrGjU',
              defaultMessage: 'Back',
              description: 'Button text to go back from the payment method updated modal',
            })}
          </TextButton>
        </Group>
      </ModalContent>
    </ModalBody>
  </>
}

export default LuxPlusManageAccountModalUpdatePaymentMethodSuccess
